// Module Import
//---------------------------------
import React from 'react'
import styled from 'styled-components'
import TextHeader from '../TextHeader/TextHeader'
import LinkAtom from '../../atoms/links/links'
import PageSummaryItem from "./PageSummaryItem";

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const PageSummaryWrapper = styled.section`
  position: relative;
`

const PageSummaryList = styled.div`
  padding: 0;
`

// Component Export
//---------------------------------
export default function PageSummary({
  title,
  subtitle,
  cardOneTitle,
  cardOneBody,
  cardTwoTitle,
  cardTwoBody,
  cardThreeTitle,
  cardThreeBody,
  linkDestination,
  linkText,
  hasButton,
  fieldsNames = {},
  variant = "primary"
}) {
  return (
    <PageSummaryWrapper>
      <div className={`outer ${variant === "primary" ? "margin-160" : ""}`}>
        <div className="inner">
          {title === null ? null : (
            <TextHeader
              titleField={fieldsNames.title}
              subtitleField={fieldsNames.subtitle}
              title={title}
              subtitle={subtitle}
            />
          )}
          <PageSummaryList className="row ">
            <PageSummaryItem variant={variant} body={cardOneBody} title={cardOneTitle} />
            <PageSummaryItem variant={variant} body={cardTwoBody} title={cardTwoTitle} />
            <PageSummaryItem variant={variant} body={cardThreeBody} title={cardThreeTitle} />
          </PageSummaryList>
          {/* Link logic */}
          {hasButton === true ? (
            <LinkAtom
              linkType="Simple Button Link"
              linkDestination={linkDestination}
              linkText={linkText}
            />
          ) : null}
        </div>
      </div>
    </PageSummaryWrapper>
  )
}

PageSummary.propTypes = {}
